export default {
  PageName: 'Line Information',
  SearchPlaceholder: 'Search for dedicated line sn / undersea cable sn/A-side IP/Z-side IP/device name/node name/line number',
  sn: 'Dedicated Line SN',
  hlSn: 'Undersea Cable SN',
  area: 'Area',
  type: 'Type',
  provider: 'Provider',
  isp	: 'Isp',
  netName: 'Net Name',
  location: 'Location',
  tenancy: 'Tenancy(day)',
  buyTime: 'Buy Time',
  dedicatedLineIp: 'Dedicated Line Ip',
  detail: 'Dedicated Line Quality Statistics',
  detailComp: {
    packetLossAvg: 'Packet Loss Avg',
    delayAvg: 'Delay Avg',
    jitterAvg: 'Jitter Avg',
  },
  ASizeIP: 'A-side IP',
  ZSizeIP: 'Z-side IP',
  Unknown: ' Unknown',
  ASideLocation: 'A-Side Location',
  ZSideLocation: 'A-Side Location',
  ispSN: 'line number',
  StartingTime: 'Starting Time',
  LeaseStopTime: 'Lease Stop Time',
  LineName: 'LineName',
  Bandwidth: 'Bandwidth',
  Port: 'Port',
}